<script setup>
import { useRoute } from '@js/utils/route';
import { ref } from 'vue';

const { taskTime, callback } = defineProps({
    taskTime: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const loading = ref(false);

function toggleTaskTimeIsUrgent() {
    loading.value = true;

    axios
        .post(
            route('front.projectManagement.task.postToggleTaskTimeIsUrgent', {
                taskTime: taskTime.id,
            }),
        )
        .then(() => {
            if (callback) {
                callback();
            }
        })
        .finally(() => {
            loading.value = false;
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="toggleTaskTimeIsUrgent" :loading="loading" />
</template>
